import { useEffect, useState } from "react";
import { Activity, Circle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { formatLocalDateTime } from "@/lib/dates";

const ROLE_COLOR = {
  admin: "text-primary-orange", plant_manager: "text-sky-400", dispatcher: "text-emerald-400",
  batcher: "text-amber-400", loader: "text-amber-400", driver: "text-zinc-300", accounts: "text-purple-400",
};

export default function ActivityLog({ className = "" }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const load = () => api.get("/activity?limit=150").then((r) => setData(r.data)).catch(() => {}).finally(() => setLoading(false));
  useEffect(() => { load(); const i = setInterval(load, 30000); return () => clearInterval(i); }, []);

  return (
    <div className={`space-y-6 ${className}`} data-testid="activity-log">
      <div>
        <div className="label-tag flex items-center gap-2 mb-2"><Circle className="w-2.5 h-2.5 fill-emerald-500 text-emerald-500 animate-pulse" /> Online now</div>
        {loading && !data ? (
          <div className="flex items-center gap-2 text-muted-industrial mono text-xs"><Loader2 className="w-4 h-4 animate-spin" /> loading…</div>
        ) : (data?.online || []).length === 0 ? (
          <div className="text-xs text-muted-industrial">No one active in the last 5 minutes.</div>
        ) : (
          <div className="flex flex-wrap gap-2" data-testid="activity-online">
            {data.online.map((u) => (
              <span key={u.id} data-testid={`online-${u.id}`} className="inline-flex items-center gap-1.5 border border-emerald-600/50 bg-emerald-500/5 px-2 py-1 mono text-[11px]">
                <Circle className="w-2 h-2 fill-emerald-500 text-emerald-500" />
                <span className="text-ink font-bold">{u.name || "—"}</span>
                <span className={`uppercase text-[9px] tracking-widest ${ROLE_COLOR[u.role] || "text-muted-industrial"}`}>{(u.role || "").replace("_", " ")}</span>
              </span>
            ))}
          </div>
        )}
      </div>

      <div>
        <div className="label-tag flex items-center gap-2 mb-2"><Activity className="w-3.5 h-3.5" /> Login history</div>
        <div className="border border-industrial max-h-[420px] overflow-y-auto">
          <table className="w-full text-left" data-testid="activity-logins">
            <thead className="sticky top-0 bg-surface-2">
              <tr className="mono text-[9px] uppercase tracking-widest text-muted-industrial">
                <th className="px-3 py-2">User</th><th className="px-3 py-2">Role</th><th className="px-3 py-2">When</th>
              </tr>
            </thead>
            <tbody>
              {(data?.logins || []).map((l) => (
                <tr key={l.id} className="border-t border-industrial/60" data-testid={`login-row-${l.id}`}>
                  <td className="px-3 py-2 mono text-xs text-ink">{l.name || l.email}</td>
                  <td className={`px-3 py-2 mono text-[10px] uppercase tracking-widest ${ROLE_COLOR[l.role] || "text-muted-industrial"}`}>{(l.role || "").replace("_", " ")}</td>
                  <td className="px-3 py-2 mono text-[11px] text-muted-industrial">{formatLocalDateTime(l.at)}</td>
                </tr>
              ))}
              {!loading && (data?.logins || []).length === 0 && (
                <tr><td colSpan={3} className="px-3 py-6 text-center text-xs text-muted-industrial">No logins recorded yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
